import { createSlice, isAnyOf } from '@reduxjs/toolkit'
import { getShouldCostModelBreakdownAsync } from 'src/services/costModelling/shouldCostLibrary.services'
import {
  TransformComponentData,
  transformData,
} from 'src/views/pages/costModelling/utils/transformCostBreakdownData'

const initialState = {
  costBreakdownData: [],
  costBreakDownLoader: false,
  subComponentBreakdownData: [],
  totalPercentage: 0,
}

export const getShouldCostBreakdownSlice = createSlice({
  name: 'cost-components-slice',
  initialState,
  extraReducers: (builder) => {
    builder.addMatcher(isAnyOf(getShouldCostModelBreakdownAsync.pending), (state) => {
      state.costBreakDownLoader = true
    })
    builder.addMatcher(isAnyOf(getShouldCostModelBreakdownAsync.fulfilled), (state, action) => {
      if (action.payload.data.length > 0) {
        const componentData = transformData(action?.payload?.data)
        state.costBreakdownData = [...componentData]

        const totalSumPercentage = componentData.reduce(
          (total, item) => total + Number(item.percentage),
          0,
        )
        state.totalPercentage = totalSumPercentage
      } else {
        state.costBreakdownData = []
        state.costBreakDownLoader = false
        state.subComponentBreakdownData = []
      }

      state.costBreakDownLoader = false
    })
    builder.addMatcher(isAnyOf(getShouldCostModelBreakdownAsync.rejected), (state, action) => {
      state.costBreakDownLoader = false
    })
  },
  reducers: {
    addCostBreakdownComponent: (state, action) => {
      state.costBreakdownData = [...state.costBreakdownData, action.payload]
    },

    removeCostBreakdownComponent: (state, action) => {
      state.costBreakdownData = state.costBreakdownData?.filter(
        (obj) => obj.label !== action?.payload,
      )
    },

    setCostBreakdownData: (state, action) => {
      state.costBreakdownData = action?.payload
    },

    setSubComponentBreakdownData: (state, action) => {
      state.subComponentBreakdownData = action?.payload
    },

    setTotalPercentage: (state, action) => {
      state.totalPercentage = action?.payload
    },

    resetCostBreakdownData: () => initialState,

    resetSubComponentBreakdownData: () => initialState,
  },
})

export const {
  addCostBreakdownComponent,
  removeCostBreakdownComponent,
  setCostBreakdownData,
  setSubComponentBreakdownData,
  setTotalPercentage,
  resetCostBreakdownData,
  resetSubComponentBreakdownData
} = getShouldCostBreakdownSlice.actions

export default getShouldCostBreakdownSlice.reducer
